export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'Rate': 'Beløb',
            'CoworkerAwaitedStatus': 'Hvis sag er i status afventende, og hvis beløbet er større end kr. "beløb", admod om aconto faktuda',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save': 'Gem',
        }
    }
};